/**
 * @generated SignedSource<<f9abe7028bc9123bfef5c1072c76b189>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScreenersElementTypeChoices = "AV" | "CM" | "DS" | "DT" | "FL" | "GS" | "MS" | "NM" | "OE" | "RH" | "RK" | "SS" | "VD" | "%future added value";
export type ScreenersParticipantIncentivizedTypeChoices = "CA" | "EX" | "PT" | "%future added value";
export type ScreenersParticipantRsvpChoices = "ACCEPTED" | "DECLINED" | "NEEDSACTION" | "TENTATIVE" | "%future added value";
export type ScreenersRespondentApprovalStatusChoices = "A" | "D" | "NR" | "%future added value";
export type ScreenersRespondentMasterStatusChoices = "A" | "CS" | "D" | "IW" | "NR" | "NS" | "OQ" | "RT" | "RW" | "S" | "SS" | "T" | "%future added value";
export type ScreenersRespondentStatusChoices = "OQ" | "Q" | "T" | "%future added value";
export type ParticipantsTableQuery$variables = {
  count: number;
  cursor?: string | null;
  elementIds?: ReadonlyArray<string | null> | null;
  excludeNonTest: boolean;
  filterComplex?: any | null;
  includeTest: boolean;
  searchTerm?: string | null;
  studyId: string;
  tab?: string | null;
};
export type ParticipantsTableQuery$data = {
  readonly viewer: {
    readonly study: {
      readonly dId: any | null;
      readonly export: {
        readonly " $fragmentSpreads": FragmentRefs<"ExportButton_export">;
      } | null;
      readonly participantsDetail: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly bonusPoints: ReadonlyArray<{
              readonly orderDate: any;
              readonly pointsAmount: number;
            } | null>;
            readonly id: string;
            readonly imported: boolean;
            readonly incentivized: boolean;
            readonly incentivizedAmount: string | null;
            readonly incentivizedOn: any | null;
            readonly incentivizedPointAmount: number | null;
            readonly incentivizedType: ScreenersParticipantIncentivizedTypeChoices | null;
            readonly noShow: boolean;
            readonly rating: number;
            readonly respondent: {
              readonly approvalStatus: ScreenersRespondentApprovalStatusChoices | null;
              readonly dId: any | null;
              readonly id: string;
              readonly masterStatus: ScreenersRespondentMasterStatusChoices | null;
              readonly person: {
                readonly email: string | null;
                readonly firstName: string | null;
                readonly lastName: string | null;
                readonly optIn: boolean;
                readonly panelist: {
                  readonly dId: any | null;
                  readonly " $fragmentSpreads": FragmentRefs<"Note_panelist">;
                } | null;
                readonly panelistDId: string | null;
                readonly phoneNumber: string | null;
              } | null;
              readonly recruit: {
                readonly incentive: string | null;
                readonly incentivePoints: number | null;
                readonly incentivesClearDate: any | null;
                readonly isTest: boolean;
                readonly name: string | null;
              } | null;
              readonly responses: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly element: {
                      readonly type: ScreenersElementTypeChoices;
                    };
                    readonly value: string;
                  } | null;
                } | null>;
              };
              readonly rhAnswer: string | null;
              readonly scheduledSlots: ReadonlyArray<{
                readonly date: any;
                readonly end: any;
                readonly interviewed: boolean;
                readonly session: {
                  readonly name: string;
                } | null;
                readonly start: any;
              }>;
              readonly screenerResults: any | null;
              readonly segmentResponses: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly segment: {
                      readonly text: string | null;
                    };
                  } | null;
                } | null>;
              };
              readonly status: ScreenersRespondentStatusChoices | null;
              readonly " $fragmentSpreads": FragmentRefs<"AlertVoxpopmeVideoAnalysis_respondent" | "Note_respondent" | "RespondentResponses_respondent" | "ScheduleModal_respondent">;
            };
            readonly rsvp: ScreenersParticipantRsvpChoices;
          } | null;
        } | null>;
        readonly totalCount: number | null;
      } | null;
      readonly screener: {
        readonly elements: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly answers: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly dbId: string;
                    readonly position: number;
                    readonly text: string | null;
                  } | null;
                } | null>;
              };
              readonly dbId: string;
              readonly position: number;
              readonly rows: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly dbId: string;
                    readonly position: number;
                    readonly text: string;
                  } | null;
                } | null>;
              };
              readonly text: string | null;
              readonly type: ScreenersElementTypeChoices;
            } | null;
          } | null>;
        } | null;
      } | null;
      readonly tenant: {
        readonly dId: any | null;
        readonly name: string;
        readonly vpmAccountId: number | null;
      };
      readonly " $fragmentSpreads": FragmentRefs<"AlertVoxpopmeVideoAnalysis_study" | "BulkScheduleModal_study" | "Cells_NextStepCell_study" | "Cells_ReviewCell_study" | "ConfirmExternalIncentiveModal_study" | "EditExternalIncentiveEmailModal_study" | "ParticipantBatchActions_study" | "ParticipantPaymentModal_study" | "ParticipantsTableHeader_study" | "ScheduleModal_study" | "SlotPicker_study">;
    } | null;
  };
};
export type ParticipantsTableQuery = {
  response: ParticipantsTableQuery$data;
  variables: ParticipantsTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "elementIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeNonTest"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterComplex"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTest"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "studyId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tab"
},
v9 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "id_In",
    "variableName": "elementIds"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vpmAccountId",
  "storageKey": null
},
v18 = {
  "kind": "Variable",
  "name": "filterComplex",
  "variableName": "filterComplex"
},
v19 = {
  "kind": "Variable",
  "name": "tab",
  "variableName": "tab"
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rhAnswer",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvalStatus",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterStatus",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "screenerResults",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "interviewed",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optIn",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "panelistDId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTest",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentive",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivePoints",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivesClearDate",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rsvp",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noShow",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivized",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivizedType",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivizedAmount",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivizedOn",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivizedPointAmount",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imported",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipantBonusPointsNode",
  "kind": "LinkedField",
  "name": "bonusPoints",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pointsAmount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "replyTo",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "moderatorEmail",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availablePlaces",
  "storageKey": null
},
v60 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StudyAvailabilitySlotNode",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v21/*: any*/),
      (v58/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v59/*: any*/)
    ],
    "storageKey": null
  }
],
v61 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "excludeNonTest",
    "variableName": "excludeNonTest"
  },
  (v18/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "includeTest",
    "variableName": "includeTest"
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  },
  (v19/*: any*/)
],
v62 = [
  (v21/*: any*/)
],
v63 = [
  (v21/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "modified",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNode",
    "kind": "LinkedField",
    "name": "modifiedBy",
    "plural": false,
    "selections": [
      (v32/*: any*/),
      (v21/*: any*/)
    ],
    "storageKey": null
  },
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ParticipantsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExportNode",
                "kind": "LinkedField",
                "name": "export",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ExportButton_export"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "ElementNodeConnection",
                    "kind": "LinkedField",
                    "name": "elements",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ElementNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ElementNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerNodeConnection",
                                "kind": "LinkedField",
                                "name": "answers",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnswerNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v15/*: any*/),
                                          (v12/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RowNodeConnection",
                                "kind": "LinkedField",
                                "name": "rows",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RowNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RowNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v15/*: any*/),
                                          (v13/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AlertVoxpopmeVideoAnalysis_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "BulkScheduleModal_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Cells_NextStepCell_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Cells_ReviewCell_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ConfirmExternalIncentiveModal_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditExternalIncentiveEmailModal_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ParticipantBatchActions_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ParticipantPaymentModal_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ParticipantsTableHeader_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ScheduleModal_study"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SlotPicker_study"
              },
              {
                "alias": "participantsDetail",
                "args": [
                  (v18/*: any*/),
                  (v19/*: any*/)
                ],
                "concreteType": "ParticipantConnection",
                "kind": "LinkedField",
                "name": "__ParticipantsTable_participantsDetail_connection",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParticipantNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RespondentNode",
                            "kind": "LinkedField",
                            "name": "respondent",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v10/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ElementResponseNodeConnection",
                                "kind": "LinkedField",
                                "name": "responses",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ElementResponseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ElementResponseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ElementNode",
                                            "kind": "LinkedField",
                                            "name": "element",
                                            "plural": false,
                                            "selections": [
                                              (v14/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v26/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SegmentResponseNodeConnection",
                                "kind": "LinkedField",
                                "name": "segmentResponses",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SegmentResponseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SegmentResponseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SegmentNode",
                                            "kind": "LinkedField",
                                            "name": "segment",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RespondentScheduledSlotNode",
                                "kind": "LinkedField",
                                "name": "scheduledSlots",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StudySessionNode",
                                    "kind": "LinkedField",
                                    "name": "session",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PersonNode",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PanelistNode",
                                    "kind": "LinkedField",
                                    "name": "panelist",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "Note_panelist"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecruitNode",
                                "kind": "LinkedField",
                                "name": "recruit",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "AlertVoxpopmeVideoAnalysis_respondent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "Note_respondent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "RespondentResponses_respondent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ScheduleModal_respondent"
                              }
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ParticipantsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExportNode",
                "kind": "LinkedField",
                "name": "export",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countTotal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentOn",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sentTo",
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "to",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ScreenerNode",
                "kind": "LinkedField",
                "name": "screener",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "ElementNodeConnection",
                    "kind": "LinkedField",
                    "name": "elements",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ElementNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ElementNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerNodeConnection",
                                "kind": "LinkedField",
                                "name": "answers",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AnswerNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnswerNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v15/*: any*/),
                                          (v12/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RowNodeConnection",
                                "kind": "LinkedField",
                                "name": "rows",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RowNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RowNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v15/*: any*/),
                                          (v13/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v21/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPortalNode",
                    "kind": "LinkedField",
                    "name": "customportal",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hidePointsAndRedemption",
                        "storageKey": null
                      },
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmailTemplateConnection",
                    "kind": "LinkedField",
                    "name": "emailTemplates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmailTemplateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmailTemplateNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v16/*: any*/),
                              (v55/*: any*/),
                              (v56/*: any*/),
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stripePaymentMethodId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stripePaymentMethodLast4",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requireStudyPayment",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "incentivesOrderFulfillmentVerificationDays",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v21/*: any*/),
              (v16/*: any*/),
              (v23/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyAvailabilitySlotConnection",
                "kind": "LinkedField",
                "name": "availabilitySlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyAvailabilitySlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v60/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventsType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StudySessionNodeConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudySessionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudySessionNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StudyAvailabilitySlotNodeConnection",
                            "kind": "LinkedField",
                            "name": "availabilitySlots",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StudyAvailabilitySlotNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v60/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RespondentScheduledSlotNodeConnection",
                            "kind": "LinkedField",
                            "name": "scheduledSlots",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RespondentScheduledSlotNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RespondentScheduledSlotNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StudyAvailabilitySlotNode",
                                        "kind": "LinkedField",
                                        "name": "studyAvailabilitySlot",
                                        "plural": false,
                                        "selections": [
                                          (v58/*: any*/),
                                          (v59/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowAutoApproval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduledBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usesApiToMarkComplete",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultIncentive",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultIncentivePoints",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incentiveType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ExternalIncentiveNode",
                "kind": "LinkedField",
                "name": "externalIncentive",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomatedEmailNode",
                    "kind": "LinkedField",
                    "name": "automatedEmail",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                      },
                      (v21/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AssetNodeConnection",
                        "kind": "LinkedField",
                        "name": "assets",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AssetNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AssetNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sizeBytes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "claimLink",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v61/*: any*/),
                "concreteType": "ParticipantConnection",
                "kind": "LinkedField",
                "name": "participantsDetail",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipantEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ParticipantNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RespondentNode",
                            "kind": "LinkedField",
                            "name": "respondent",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v10/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ElementResponseNodeConnection",
                                "kind": "LinkedField",
                                "name": "responses",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ElementResponseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ElementResponseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ElementNode",
                                            "kind": "LinkedField",
                                            "name": "element",
                                            "plural": false,
                                            "selections": [
                                              (v14/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v26/*: any*/),
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v27/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SegmentResponseNodeConnection",
                                "kind": "LinkedField",
                                "name": "segmentResponses",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SegmentResponseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SegmentResponseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SegmentNode",
                                            "kind": "LinkedField",
                                            "name": "segment",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v21/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RespondentScheduledSlotNode",
                                "kind": "LinkedField",
                                "name": "scheduledSlots",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StudySessionNode",
                                    "kind": "LinkedField",
                                    "name": "session",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StudyAvailabilitySlotNode",
                                    "kind": "LinkedField",
                                    "name": "studyAvailabilitySlot",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StudySessionNode",
                                        "kind": "LinkedField",
                                        "name": "session",
                                        "plural": false,
                                        "selections": (v62/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PersonNode",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v37/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PanelistNode",
                                    "kind": "LinkedField",
                                    "name": "panelist",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v21/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NoteNode",
                                        "kind": "LinkedField",
                                        "name": "tenantNote",
                                        "plural": false,
                                        "selections": (v63/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v21/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecruitNode",
                                "kind": "LinkedField",
                                "name": "recruit",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v21/*: any*/),
                                  (v12/*: any*/),
                                  (v14/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NoteNode",
                                "kind": "LinkedField",
                                "name": "note",
                                "plural": false,
                                "selections": (v63/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParticipantNode",
                                "kind": "LinkedField",
                                "name": "participant",
                                "plural": false,
                                "selections": (v62/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v54/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v61/*: any*/),
                "filters": [
                  "filterComplex",
                  "tab"
                ],
                "handle": "connection",
                "key": "ParticipantsTable_participantsDetail",
                "kind": "LinkedHandle",
                "name": "participantsDetail"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "977f7934a42bdbe2ec0498a14c57b63a",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "count",
          "cursor": "cursor",
          "direction": "forward",
          "path": [
            "viewer",
            "study",
            "participantsDetail"
          ]
        }
      ]
    },
    "name": "ParticipantsTableQuery",
    "operationKind": "query",
    "text": "query ParticipantsTableQuery(\n  $count: Int!\n  $cursor: String\n  $studyId: String!\n  $filterComplex: GenericScalar\n  $excludeNonTest: Boolean!\n  $includeTest: Boolean!\n  $tab: String\n  $searchTerm: String\n  $elementIds: [ID]\n) {\n  viewer {\n    study(studyId: $studyId) {\n      dId\n      export {\n        ...ExportButton_export\n        id\n      }\n      screener {\n        elements(id_In: $elementIds) {\n          edges {\n            node {\n              dbId\n              position\n              type\n              text\n              answers {\n                edges {\n                  node {\n                    position\n                    text\n                    dbId\n                    id\n                  }\n                }\n              }\n              rows {\n                edges {\n                  node {\n                    dbId\n                    text\n                    position\n                    id\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      tenant {\n        dId\n        name\n        vpmAccountId\n        id\n      }\n      ...AlertVoxpopmeVideoAnalysis_study\n      ...BulkScheduleModal_study\n      ...Cells_NextStepCell_study\n      ...Cells_ReviewCell_study\n      ...ConfirmExternalIncentiveModal_study\n      ...EditExternalIncentiveEmailModal_study\n      ...ParticipantBatchActions_study\n      ...ParticipantPaymentModal_study\n      ...ParticipantsTableHeader_study\n      ...ScheduleModal_study\n      ...SlotPicker_study\n      participantsDetail(first: $count, after: $cursor, filterComplex: $filterComplex, excludeNonTest: $excludeNonTest, includeTest: $includeTest, tab: $tab, searchTerm: $searchTerm) {\n        totalCount\n        edges {\n          node {\n            id\n            respondent {\n              id\n              dId\n              rhAnswer\n              status\n              approvalStatus\n              masterStatus\n              responses {\n                edges {\n                  node {\n                    element {\n                      type\n                      id\n                    }\n                    value\n                    id\n                  }\n                }\n              }\n              screenerResults\n              segmentResponses {\n                edges {\n                  node {\n                    segment {\n                      text\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              scheduledSlots {\n                session {\n                  name\n                  id\n                }\n                date\n                start\n                end\n                interviewed\n                id\n              }\n              person {\n                firstName\n                lastName\n                email\n                phoneNumber\n                optIn\n                panelistDId\n                panelist {\n                  dId\n                  ...Note_panelist\n                  id\n                }\n                id\n              }\n              recruit {\n                name\n                isTest\n                incentive\n                incentivePoints\n                incentivesClearDate\n                id\n              }\n              ...AlertVoxpopmeVideoAnalysis_respondent\n              ...Note_respondent\n              ...RespondentResponses_respondent\n              ...ScheduleModal_respondent\n            }\n            rsvp\n            noShow\n            rating\n            incentivized\n            incentivizedType\n            incentivizedAmount\n            incentivizedOn\n            incentivizedPointAmount\n            imported\n            bonusPoints {\n              orderDate\n              pointsAmount\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AlertVoxpopmeVideoAnalysis_respondent on RespondentNode {\n  id\n  dId\n  recruit {\n    id\n    dbId\n    name\n    type\n  }\n}\n\nfragment AlertVoxpopmeVideoAnalysis_study on StudyNode {\n  id\n  dId\n  name\n  status\n  tenant {\n    id\n    dId\n    name\n    vpmAccountId\n  }\n  type\n}\n\nfragment BulkScheduleModal_study on StudyNode {\n  id\n  availabilitySlots {\n    edges {\n      node {\n        id\n        moderatorEmail\n        start\n        end\n        availablePlaces\n      }\n    }\n  }\n  ...SlotPicker_study\n}\n\nfragment Cells_ApproveRejectedCell_study on StudyNode {\n  id\n  type\n  scheduledBy\n  usesApiToMarkComplete\n}\n\nfragment Cells_NextStepCell_study on StudyNode {\n  allowAutoApproval\n  scheduled\n  type\n  schedulingType\n  scheduledBy\n  ...Cells_ApproveRejectedCell_study\n  ...Cells_PaymentCell_study\n  ...ScheduleCell_study\n  ...ScheduledSlotCell_study\n}\n\nfragment Cells_PaymentCell_study on StudyNode {\n  defaultIncentive\n  defaultIncentivePoints\n  incentiveType\n  status\n  tenant {\n    customportal {\n      hidePointsAndRedemption\n      id\n    }\n    id\n  }\n  ...ConfirmExternalIncentiveModal_study\n  ...ParticipantPaymentModal_study\n}\n\nfragment Cells_ReviewCell_study on StudyNode {\n  id\n  dId\n  name\n  status\n  type\n  tenant {\n    dId\n    name\n    vpmAccountId\n    id\n  }\n}\n\nfragment ConfirmExternalIncentiveModal_study on StudyNode {\n  externalIncentive {\n    automatedEmail {\n      enabled\n      id\n    }\n    id\n  }\n  ...EditExternalIncentiveEmailModal_study\n}\n\nfragment EditExternalIncentiveEmailModal_study on StudyNode {\n  id\n  externalIncentive {\n    claimLink\n    automatedEmail {\n      replyTo\n      subject\n      message\n      ctaLabel\n      ctaUrl\n      assets {\n        edges {\n          node {\n            id\n            name\n            sizeBytes\n            url\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  tenant {\n    emailTemplates {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    ...SaveTemplateModal_tenant\n    ...SelectTemplateModal_tenant\n    id\n  }\n}\n\nfragment ExportButton_export on ExportNode {\n  id\n  countCompleted\n  countTotal\n  sentOn\n  sentTo\n  status\n  to {\n    email\n    id\n  }\n}\n\nfragment GivePointsModal_tenant on TenantNode {\n  ...GivePointsPaymentModal_tenant\n}\n\nfragment GivePointsPaymentModal_tenant on TenantNode {\n  requireStudyPayment\n  incentivesOrderFulfillmentVerificationDays\n  stripePaymentMethodId\n  stripePaymentMethodLast4\n}\n\nfragment GivePointsToParticipantsModal_tenant on TenantNode {\n  ...GivePointsModal_tenant\n}\n\nfragment Note_panelist on PanelistNode {\n  id\n  tenantNote {\n    id\n    modified\n    modifiedBy {\n      firstName\n      id\n    }\n    text\n  }\n}\n\nfragment Note_respondent on RespondentNode {\n  id\n  note {\n    id\n    modified\n    modifiedBy {\n      firstName\n      id\n    }\n    text\n  }\n}\n\nfragment ParticipantBatchActions_study on StudyNode {\n  id\n  type\n  incentiveType\n  status\n  ...BulkScheduleModal_study\n  ...ConfirmExternalIncentiveModal_study\n  ...EditExternalIncentiveEmailModal_study\n  ...ParticipantPaymentModal_study\n  ...SlotPicker_study\n  tenant {\n    ...GivePointsToParticipantsModal_tenant\n    customportal {\n      hidePointsAndRedemption\n      id\n    }\n    id\n  }\n}\n\nfragment ParticipantPaymentModal_study on StudyNode {\n  tenant {\n    stripePaymentMethodId\n    stripePaymentMethodLast4\n    id\n  }\n}\n\nfragment ParticipantsTableHeader_study on StudyNode {\n  id\n  dId\n  export {\n    ...ExportButton_export\n    id\n  }\n  name\n  type\n  usesApiToMarkComplete\n}\n\nfragment RespondentResponses_ModalContent_respondent on RespondentNode {\n  dId\n  rhAnswer\n}\n\nfragment RespondentResponses_respondent on RespondentNode {\n  id\n  ...RespondentResponses_ModalContent_respondent\n}\n\nfragment SaveTemplateModal_tenant on TenantNode {\n  emailTemplates {\n    edges {\n      node {\n        id\n        name\n        replyTo\n        subject\n        message\n      }\n    }\n  }\n}\n\nfragment ScheduleCell_study on StudyNode {\n  id\n  scheduledBy\n  schedulingType\n  ...ScheduleModal_study\n}\n\nfragment ScheduleModal_respondent on RespondentNode {\n  id\n  participant {\n    id\n  }\n  scheduledSlots {\n    id\n    studyAvailabilitySlot {\n      id\n      start\n      end\n      session {\n        id\n      }\n    }\n  }\n}\n\nfragment ScheduleModal_study on StudyNode {\n  id\n  type\n  eventsType\n  sessions {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  availabilitySlots {\n    edges {\n      node {\n        id\n        moderatorEmail\n        start\n        end\n        availablePlaces\n      }\n    }\n  }\n  ...SlotPicker_study\n}\n\nfragment ScheduledSlotCell_study on StudyNode {\n  id\n  type\n  availabilitySlots {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...ScheduleModal_study\n}\n\nfragment SelectTemplateModal_tenant on TenantNode {\n  emailTemplates {\n    edges {\n      node {\n        id\n        name\n        replyTo\n        subject\n        message\n      }\n    }\n  }\n}\n\nfragment SlotPicker_study on StudyNode {\n  id\n  type\n  eventsType\n  sessions {\n    edges {\n      node {\n        id\n        name\n        availabilitySlots {\n          edges {\n            node {\n              id\n              moderatorEmail\n              start\n              end\n              availablePlaces\n            }\n          }\n        }\n        scheduledSlots {\n          edges {\n            node {\n              id\n              start\n              end\n              studyAvailabilitySlot {\n                moderatorEmail\n                availablePlaces\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "afe48afde35242bd2bc9ed76b3975b12";

export default node;
